export * from './name.component';
export * from './names.component';
export * from './personname';
export * from '../../hospitalSetup/titles-codes/title.service';
